import React from 'react';
import styles from './ConnectedRadio.mod.css';
import classnames from 'classnames/bind';

let cx = classnames.bind(styles);

const ConnectedRadio = ({ data, values, id, setFieldValue, error }) => {
  const defaultValues = data.question_answers.reduce(
    (defaultValues, { id }) => {
      defaultValues[id] = false;
      return defaultValues;
    },
    {}
  );

  const handleChange = checkedId => {
    setFieldValue(id, {
      ...values,
      [data.id]: { ...defaultValues, [checkedId]: true }
    });
  };

  return (
    <div className={cx('column', { error })}>
      {data.question_answers.map(({ title, id }, index) => (
        <label key={index} className={cx('label')}>
          <span className={cx('title')}>{title}</span>
          <input
            name={id}
            type="radio"
            checked={values[data.id][id]}
            onChange={() => handleChange(id)}
            className={cx('input')}
          />
          <span className={cx('circle')} />
        </label>
      ))}
    </div>
  );
};

export default ConnectedRadio;



// WEBPACK FOOTER //
// ./src/containers/Module/components/СonnectedRadio.jsx